import { render, staticRenderFns } from "./notice.vue?vue&type=template&id=4f859ae2&"
import script from "./notice.vue?vue&type=script&lang=js&"
export * from "./notice.vue?vue&type=script&lang=js&"
import style0 from "./notice.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f859ae2')) {
      api.createRecord('4f859ae2', component.options)
    } else {
      api.reload('4f859ae2', component.options)
    }
    module.hot.accept("./notice.vue?vue&type=template&id=4f859ae2&", function () {
      api.rerender('4f859ae2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/notice/notice.vue"
export default component.exports